









































































import { Component, Vue } from "vue-property-decorator";
import userModule from "../store/modules/user";
import assessments from "../store/modules/assessments";
import { PUBLIC_PATH } from "@/config"

@Component({
  components: {}
})
export default class loginView extends Vue {
  username: string = "";
  password: string = "";
  invalidEntryDialog: boolean = false;

  async login() {
    const isLoginSuccess = await userModule.login({
      username: this.username,
      password: this.password
    });
    if (isLoginSuccess) {
      this.$router.push({path: PUBLIC_PATH + "/assessments"});
      this.password = "";
    } else {
      this.invalidEntryDialog = true;
    }
  }
}
